import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { Dispositivo } from 'app/models/dispositivo.model';
import { Compartimento } from 'app/models/compartimento.model';
import { TamanhoCompartimento } from 'app/models/tamanhoCompartimento.model';
import { AppFilter } from 'app/models/app-filter.model';
import { AbDispositivo } from 'app/abstract/full-pages/locker/dispositivo.abstract';
@Injectable({
  providedIn: 'root'
})
export class DispositivoService extends AbDispositivo {

  mostrarButtonAdicionar: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  constructor(http: HttpClient) {
    super(http);
  }

  public carregarDispositivo(id: number) {
    return this.get('dispositivos/carregar/' + id);
  }

  public conectarDispositivo(dispositivo: Dispositivo): Observable<any> {
    return this.http.post(this.url + "dispositivos/conectar/", dispositivo);
  }

  public testeConexaoDispositivoCaixaCorreioInteligente(config): Observable<any> {
    return this.http.post(this.url + "dispositivos/testeconexao/armario", config);
  }

  public testeConexaoDispositivoLockerPadrao(config): Observable<any> {
    return this.http.post(this.url + "dispositivos/testeconexao/armario/padrao", config);
  }

  public carregarTamanhosCompartimento(id: number) {
    return this.get('dispositivos/carregarTamanhosCompartimento/' + id);
  }

  public abrirPortaCompartimentoTamanho(tamanhoCompartimento: TamanhoCompartimento): Observable<any> {
    return this.http.post(this.url + "dispositivos/abrirPortaCorrespondencia/", tamanhoCompartimento);
  }

  public abrirPortaCompartimento(compartimento: Compartimento): Observable<any> {
    return this.http.post(this.url + "dispositivos/abrirPortaRetirada/", compartimento);
  }

  public buscarAcessoGPS(): Observable<any> {
    return this.get('acessoGPS/buscar/');
  }

  public getAllFabricantesControleAcessoAtivos() {
    return this.get('fabricantes/controle_acesso/ativos/');
  }

  public getAllFabricantesVoipAtivos() {
    return this.get('fabricantes/voip/ativos/');
  }

  public salvar(dispositivo: Dispositivo): Observable<any> {
    return this.save("dispositivos/", dispositivo);
  }

  public salvarBiccateca(dispositivo: Dispositivo): Observable<any> {
    return this.save("dispositivos/alterarBiccateca/", dispositivo);
  }

  public salvarLocker(dispositivo: Dispositivo): Observable<any> {
    return this.post("dispositivos/padrao/", dispositivo);
  }

  public desativar(id: number) {
    return this.delete("dispositivos/desativar/", id);
  }

  public getAllDispositivos(filter: AppFilter): Observable<any> {
    return this.get(`dispositivos/ativos/${filter.encode()}`);
  }

  public getAllDispositivosVoip(filter: AppFilter): Observable<any> {
    return this.get(`dispositivos/voip/${filter.encode()}`);
  }

  public getAllDispositivosLocker(filter: AppFilter): Observable<any> {
    return this.get(`dispositivos/locker/${filter.encode()}`);
  }

  public getAllDispositivosLockerGenerico(filter: AppFilter): Observable<any> {
    return this.get(`dispositivos/lockerGenerico/${filter.encode()}`);
  }

  public testarConexao(dispositivo: Dispositivo) {
    return this.http.post(this.url + 'dispositivos/testarConexao/', dispositivo);
  }

  public getDispositivosLockerSemCaixaCorreioInteligente(): Observable<any> {
    return this.get(`dispositivos/dispositivosLocker/semCaixaCorreioInteligente`);
  }

  public sincronizarSenhas(): Observable<any> {
    return this.get(`login_locker/sincronizar_senhas`);
  }

  public getModeloNome(modeloNome: string) {
    return this.get(`dispositivos/modelo/${modeloNome}/`);
  }

  public salvarByModelo(dispositivo: any) {
    return this.http.post(this.url + "dispositivos/salvarModelo/", dispositivo);
  }

  public getDispositivosControlaAcesso() {
    return this.get(`dispositivos/controlaAcesso`);
  }

  public getAllFabricantesAtivos() {
    return this.get('fabricantes/ativos/');
  }

  public getAllFabricantesControlaAcesso() {
    return this.get('fabricantes/controlaAcesso');
  }

  public getAllFabricante(fabricanteId: number) {
    return this.get(`modelos/fabricante/${fabricanteId}`);
  }

  public getAllModelosFabricanteControlaAcesso(fabricanteId: number) {
    return this.get(`modelos/controlaAcesso/${fabricanteId}`);
  }

  public getAllVoipFabricante(fabricanteId: number) {
    return this.get(`modelos/voip/${fabricanteId}`);
  }

  public getAllDispositivosColeta(tipoColeta: any): Observable<any> {
    return this.get(`dispositivos/coleta/ativos/${tipoColeta}`);
  }

  public getAllDispositivosEntrega(filter: AppFilter): Observable<any> {
    return this.get(`dispositivos/entregas/${filter.encode()}`);
  }

  public salvarEntregaAutonoma(dispositivoEntregaDTO): Observable<any> {
    return this.post("dispositivos/salvarEntrega/", dispositivoEntregaDTO);
  }

  public getDispositivoEntregaById(dispositivoId: number): Observable<any> {
    return this.get(`public/dispositivos/buscarEntrega/${dispositivoId}`);
  }

  public abrirCompartimento(dispositivoEntregaDTO: any): Observable<any> {
    return this.post("public/dispositivos/abrir_porta", dispositivoEntregaDTO);
  }

  public salvarCorrespondencia(correspondenciaDTO: any): Observable<any> {
    return this.post("public/dispositivos/salvar_correspondencia", correspondenciaDTO);
  }

  public getComprovanteById(dispositivoId: number): Observable<any> {
    return this.get(`public/dispositivos/comprovante/${dispositivoId}`);
  }

  public abrirCompartimentoBoxAI(dispositivoEntregaDTO: any): Observable<any> {
    return this.post("public/dispositivos/acionar_compartimento", dispositivoEntregaDTO);
  }

  public atualizarDescricao(id: number, dispositivo: any): Observable<any> {
    return this.put(`dispositivos/descricao`, id, dispositivo);
  }

  getDispositivo(id: number): Observable<any> {
    return this.get("dispositivos/", id);
  }

  public getStatusEntregaAutonomaAguardando(id: number): Observable<any> {
    return this.get('public/dispositivos/entrega-autonoma-aguardando/' + id + '/status');
  }

}
